<form
  name="editUsersInRole"
  (ngSubmit)="editUsersInRole()"
  #editRoleForm="ngForm"
  class="container mt-5"
>
  <div class="card">
    <div class="card-header">
      <h3>Role: {{ roleName }}</h3>
    </div>
    <div class="card-header">
      <h4>Add or Remove Users From This Role</h4>
    </div>
    <div class="card-body">
      @for(userRoleViewModel of userRoleViewModels; track
      userRoleViewModel.userId) {
      <div class="form-check m-1">
        <input type="hidden" [value]="userRoleViewModel.userId" />
        <input type="hidden" [value]="userRoleViewModel.userName" />
        <input
          type="checkbox"
          [(ngModel)]="userRoleViewModel.isSelected"
          #isSelected="ngModel"
          id="isSelected_{{ $index }}"
          name="isSelected_{{ $index }}"
          class="form-check-input"
        />
        <label for="isSelected_{{ $index }}" class="form-check-label">
          {{ userRoleViewModel.userName }}
        </label>
      </div>
      }
    </div>
    <div class="card-footer">
      <input
        type="submit"
        value="Update"
        class="btn btn-primary me-2"
        style="width: auto"
      />
      <a
        [href]="
          '/edit_role?roleId=' +
          roleId +
          '&roleName=' +
          roleName +
          '&description=' +
          roleDescription
        "
        class="btn btn-secondary"
        style="width: auto"
        >Cancel</a
      >
    </div>
  </div>
</form>
